module.exports = __webpack_public_path__ + "static/media/img003.79ecccc3.jpg";